import _ from 'lodash';
const ipOctet = '(?:25[0-5]|2[0-4]\\d|[01]?\\d\\d?)';
const ipPattern = `^(?:${ipOctet}\\.){3}${ipOctet}$`;
const fqdnPattern = '(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{1,63}(?<!-)\\.)+[a-zA-Z]{2,63}$)';
const pattern = `${ipPattern}|${fqdnPattern}`;
export class HostComponent {
    key;
    label;
    title;
    type;
    columns;
    constructor(config = {}) {
        this.key = `HostColumns${config.key ? `-${config.key}` : ''}`;
        this.label = config.label || _.startCase(config.key);
        this.title = this.label;
        this.type = 'columns';
        this.columns = [
            {
                components: [
                    {
                        label: 'Protocol <i class="far fa-exclamation-triangle text-warning" ' +
                            'style="cursor: pointer; margin-left: 5px;" ' +
                            'title="HTTPS protocol requires DeviceNode version v3.23.0 or higher. ' +
                            'Please ensure your DeviceNode is up to date to use HTTPS."></i>',
                        key: 'protocol',
                        type: 'select',
                        data: {
                            values: [
                                { label: 'HTTP', value: 'http' },
                                { label: 'HTTPS', value: 'https' }
                            ]
                        },
                        defaultValue: 'http',
                        searchEnabled: false,
                        removeItemButton: false,
                        validate: {
                            onlyAvailableItems: true,
                        },
                        ..._.get(config, 'componentOverrides.protocol', {})
                    }
                ],
                width: 2,
                size: 'md'
            },
            {
                components: [
                    {
                        label: 'Address',
                        key: 'ip',
                        type: 'textfield',
                        spellcheck: false,
                        validate: {
                            pattern,
                            customMessage: 'Please enter a valid IP address or FQDN.'
                        },
                        ..._.get(config, 'componentOverrides.ip', {})
                    }
                ],
                width: 8,
                size: 'md'
            },
            {
                components: [
                    {
                        label: 'Port',
                        key: 'port',
                        type: 'number',
                        ..._.get(config, 'componentOverrides.port', {})
                    }
                ],
                width: 2,
                size: 'md'
            },
        ];
    }
}
